const PARAGRAPH_AUTHORS_LISTING = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on AuthorsListing {
      id
      listing {
        title
        nid
        pathAlias
        ... on Author {
          authorTitle
          reddit
          twitter
          google
          featuredImage {
            alt
            authorPortrait
          }
        }
      }
      type
      topList {
        title
        nid
        pathAlias
        ... on Author {
          authorTitle
          reddit
          twitter
          google
          featuredImage {
            alt
            authorPortrait
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_AUTHORS_LISTING;
